<template>
    <div class="fhv-centent"  v-loading="loading" >
        <h4 class="title-topic">Account Management - Logs</h4>
          <el-form
            :model="form"
            :rules="rules"
            ref="forms" 
            label-width="150px" 
            label-position="left"
            class="fhv-form" 
            size="mini"
            :disabled="$G_DEVICE_CFG.isReadOnly"
            >
            <el-form-item label="Enable Log">
                <el-switch v-model="flag"></el-switch>
            </el-form-item>
            <el-form-item >
                <div class="el-checkbox-group">
                    <el-checkbox  v-model="system">System All</el-checkbox>
                    <el-checkbox  v-model="wireless" :disabled="system">Wireless</el-checkbox>
                    <el-checkbox  v-model="dos" :disabled="system">DoS</el-checkbox>
                </div>
            </el-form-item>
            <el-form-item label="Enable Remote Log">
                <el-switch v-model="remote"></el-switch>
            </el-form-item>
            <el-form-item label="Enable Remote Log"  prop="address">
                <el-input :disabled="!remote" v-model="form.address"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="save">Apply</el-button>
            </el-form-item>
            
        </el-form>
        
        <div class="btn-contain">
             
        </div>

        <div class="texta">
            <textarea name="" id="" v-html="sysLogList"></textarea>
             <div class="btn-contain">
                <el-button type="primary" @click="save(1)" :disabled="$G_DEVICE_CFG.isReadOnly">Clear Log File</el-button>
                <el-button type="primary" :disabled="!flag" @click="downLoad">Download Log File</el-button>
                <el-button type="primary" @click="getData" :disabled="$G_DEVICE_CFG.isReadOnly">Refresh</el-button>
            </div>
        </div>
    </div>
    
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      flag: false,
      system: false,
      wireless: false,
      dos: false,
      remote: false,
      sysLogList: "",
      form: {
        address: ""
      },
      rules: {
        address: [
          {
            validator: (rule, value, callback) => {
              if (this.remote == true) {
                if (!validator.isIP(value, 4)) {
                  callback(
                    new Error(
                      "syslog_invalid_server_address range in 4th digit. It should be 1-254!"
                    )
                  );
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    getData() {
      this.loading = true;
      axios.post("/boafrm/getLogStatus").then(res => {
        this.loading = false;
        if (res.data.logEnabled == 1) {
          this.flag = true;
        } else if (res.data.logEnabled == 3) {
          this.flag = true;
          this.system = true;
        } else if (res.data.logEnabled == 5) {
          this.flag = true;
          this.wireless = true;
        } else if (res.data.logEnabled == 9) {
          this.flag = true;
          this.dos = true;
        } else if (res.data.logEnabled == 13) {
          this.flag = true;
          this.wireless = true;
          this.dos = true;
        } else if (res.data.logEnabled == 15) {
          this.system = true;
          this.flag = true;
          this.wireless = true;
          this.dos = true;
        }
        if (res.data.rtLogEnabled == 1) {
          this.remote = true;
        }
        this.form.address = res.data.rtLogServer;
      });

      axios.post("/boafrm/getLogListStatus").then(res => {
        this.loading = false;
        // console.log(res.data);
        this.sysLogList = "";
        this.sysLogList = res.data;
      });
    },
    save(flag) {
      let postData = {
        logEnabled: this.flag == true ? "ON" : "",
        syslogEnabled: this.system == true ? "ON" : "",
        wlanlogEnabled: this.wireless == true ? "ON" : "",
        doslogEnabled: this.dos == true ? "ON" : "",
        rtLogEnabled: this.remote == true ? "ON" : "",
        logServer: this.form.address,
        Apply: "Apply Changes",
        "submit-url": "/syslog.htm"
      };
      if (flag == 1) {
        postData.clear = "Clear";
      }
      this.$refs["forms"].validate(valid => {
        if (valid) {
          this.loading = true;
          axios.post("/boafrm/setformSysLog", postData).then(res => {
            this.loading = false;
            this.$message.success(res.data.msg);
            this.getData();
          });
        }
      });
    },
    downLoad() {
      this.loading = true;
      axios({
        method: "post",
        url: "/boafrm/setfhDownloadLog",
        data: { download: "Log download" },
        responseType: "blod"
      }).then(res => {
        this.loading = false;
        if (res.data.result == "error") {
          this.$message.error(res.data.msg);
          return;
        }
        const content = res.data;
        const blob = new Blob([content]);
        const fileName = "syslog.tar";
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
    }
  },
  created() {
    this.getData();
  }
};
</script>
<style lang="scss" scoped>
.fhv-centent {
  .texta {
    textarea {
      display: inline-block;
      width: 100%;
      height: 214px;
      resize: none;
      margin-bottom: 25px;
    }
    .btn-contain {
      width: 100%;
      text-align: left;
      padding: 0;
    }
  }
  > .btn-contain {
    width: 200px;
    padding: 0;
    text-align: left;
    margin-bottom: 25px;
  }
}
.fhv-form{
    margin-left: 0;
}
</style>





